// src/pages/admin/Records.tsx
import React, { useState } from "react";
import Header from "../../components/layouts/header";
import EmbryoScope from "./EmbryoScope";
import Geri from "./Geri";
import Miri from "./Miri";
import Primo from "./Primo";

const Records: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "embryoscope" | "geri" | "miri" | "primo"
  >("embryoscope");

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Tabs */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-4 sm:space-x-8">
            <button
              onClick={() => setActiveTab("embryoscope")}
              className={`py-4 px-2 font-medium text-sm sm:text-base border-b-2 transition-colors ${
                activeTab === "embryoscope"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              EmbryoScope
            </button>
            <button
              onClick={() => setActiveTab("geri")}
              className={`py-4 px-2 font-medium text-sm sm:text-base border-b-2 transition-colors ${
                activeTab === "geri"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              GERI
            </button>
            <button
              onClick={() => setActiveTab("primo")}
              className={`py-4 px-2 font-medium text-sm sm:text-base border-b-2 transition-colors ${
                activeTab === "primo"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Primo Vision
            </button>
            <button
              onClick={() => setActiveTab("miri")}
              className={`py-4 px-2 font-medium text-sm sm:text-base border-b-2 transition-colors ${
                activeTab === "miri"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              MIRI TL
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {activeTab === "embryoscope" ? (
          <EmbryoScope />
        ) : activeTab === "geri" ? (
          <Geri />
        ) : activeTab === "primo" ? (
          <Primo />
        ) : (
          <Miri />
        )}
      </div>
    </div>
  );
};

export default Records;
